module.exports = __webpack_public_path__ + "img/Frame 5113.4cfc2320.jpg";